<template>
  <b-card class="bedroom-card mb-0" no-body>

    <div class="bedroom-card__header d-flex align-items-center px-2 py-75">
      <feather-icon icon="MoonIcon" size="13" class="text-primary mr-75 flex-shrink-0" />
      <span class="font-weight-bold small">{{ title }}</span>
    </div>

    <template v-if="beds.length">
      <div v-for="(bed, index) in beds" :key="`bed-${bedroom.id}-${index}`" class="px-1 py-75"
        :class="{ 'border-top': index > 0 }">
        <div class="small font-weight-bold">{{ bedTypeName(bed) }}</div>
        <small v-if="bedDescriptionText(bed)" class="text-muted">{{ bedDescriptionText(bed) }}</small>
      </div>
    </template>
    <div v-else class="px-1 py-75 small text-muted">{{ $t("No beds defined") }}</div>

  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import { getBedTypeName, getBedDescriptionText } from "@methods";

export default {
  components: {
    BCard, FeatherIcon,
  },
  props: {
    bedroom: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    beds() {
      return Array.isArray(this.bedroom.beds) ? this.bedroom.beds : [];
    },
  },
  methods: {
    bedTypeName(bed) {
      return getBedTypeName(bed.type, this.$i18n.locale) || this.$t("Not defined");
    },
    bedDescriptionText(bed) {
      return getBedDescriptionText(bed, this.$i18n.locale);
    },
  },
};
</script>

<style lang="scss">
.bedroom-card {
  &__header {
    background-color: #f6f6f6;
  }
}
</style>
